import { datadogRum } from '@datadog/browser-rum';
import { datadogLogs } from '@datadog/browser-logs';

import config, { matchesEnvironment } from './utils/config';

datadogRum.init({
  ...(config.datadog as any),
  site: 'datadoghq.com',
  service: 'passport',
  version: config.version,
  sessionSampleRate: 100,
  sessionReplaySampleRate: 0,
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
});
datadogRum.setGlobalContextProperty('app', 'ui');
datadogRum.setGlobalContextProperty('component', 'passport');
datadogRum.setGlobalContextProperty('owner', 'cx-forge');

datadogLogs.init({
  ...(config.datadog as any),
  site: 'datadoghq.com',
  service: 'passport',
  version: config.version,
  forwardConsoleLogs: matchesEnvironment('local') ? [] : ['error'],
  sessionSampleRate: 100,
});
